export const namespace = 'watchList'
